import {
  FETCH_TEAMS, FETCH_TEAMS_SUCCESS, FETCH_TEAMS_FAIL,
  FETCH_TEAM, FETCH_TEAM_SUCCESS, FETCH_TEAM_FAIL, CLEAR_SELECTED_TEAM,
  CREATE_TEAM, CREATE_TEAM_SUCCESS, CREATE_TEAM_FAIL,
  UPDATE_TEAM, UPDATE_TEAM_SUCCESS, UPDATE_TEAM_FAIL,
  DELETE_TEAM, DELETE_TEAM_SUCCESS, DELETE_TEAM_FAIL,
  ADD_TEAM_MEMBER, ADD_TEAM_MEMBER_SUCCESS, ADD_TEAM_MEMBER_FAIL,
  REMOVE_TEAM_MEMBER, REMOVE_TEAM_MEMBER_SUCCESS, REMOVE_TEAM_MEMBER_FAIL,
  UPDATE_TEAM_MEMBER_ROLE, UPDATE_TEAM_MEMBER_ROLE_SUCCESS, UPDATE_TEAM_MEMBER_ROLE_FAIL,
  FETCH_TEAM_RESPONSIBILITIES, FETCH_TEAM_RESPONSIBILITIES_SUCCESS, FETCH_TEAM_RESPONSIBILITIES_FAIL,
  ATTACH_TEAM_RESPONSIBILITY, ATTACH_TEAM_RESPONSIBILITY_SUCCESS, ATTACH_TEAM_RESPONSIBILITY_FAIL,
  ATTACH_TEAM_RESPONSIBILITIES_BULK, ATTACH_TEAM_RESPONSIBILITIES_BULK_SUCCESS, ATTACH_TEAM_RESPONSIBILITIES_BULK_FAIL,
  DETACH_TEAM_RESPONSIBILITY, DETACH_TEAM_RESPONSIBILITY_SUCCESS, DETACH_TEAM_RESPONSIBILITY_FAIL,
  CLEAR_TEAM_MESSAGES,
} from './actionTypes';

// List
export const fetchTeams = () => ({ type: FETCH_TEAMS });
export const fetchTeamsSuccess = (teams) => ({ type: FETCH_TEAMS_SUCCESS, payload: teams });
export const fetchTeamsFail = (error) => ({ type: FETCH_TEAMS_FAIL, payload: error });

// Detail
export const fetchTeam = (id) => ({ type: FETCH_TEAM, payload: id });
export const fetchTeamSuccess = (team) => ({ type: FETCH_TEAM_SUCCESS, payload: team });
export const fetchTeamFail = (error) => ({ type: FETCH_TEAM_FAIL, payload: error });
export const clearSelectedTeam = () => ({ type: CLEAR_SELECTED_TEAM });

// Create
export const createTeam = (data, callback) => ({ type: CREATE_TEAM, payload: { data, callback } });
export const createTeamSuccess = (team) => ({ type: CREATE_TEAM_SUCCESS, payload: team });
export const createTeamFail = (error) => ({ type: CREATE_TEAM_FAIL, payload: error });

// Update
export const updateTeam = (data, callback) => ({ type: UPDATE_TEAM, payload: { data, callback } });
export const updateTeamSuccess = (team) => ({ type: UPDATE_TEAM_SUCCESS, payload: team });
export const updateTeamFail = (error) => ({ type: UPDATE_TEAM_FAIL, payload: error });

// Delete
export const deleteTeam = (id, callback) => ({ type: DELETE_TEAM, payload: { id, callback } });
export const deleteTeamSuccess = (id) => ({ type: DELETE_TEAM_SUCCESS, payload: id });
export const deleteTeamFail = (error) => ({ type: DELETE_TEAM_FAIL, payload: error });

// Members
export const addTeamMember = (data, callback) => ({ type: ADD_TEAM_MEMBER, payload: { data, callback } });
export const addTeamMemberSuccess = (member) => ({ type: ADD_TEAM_MEMBER_SUCCESS, payload: member });
export const addTeamMemberFail = (error) => ({ type: ADD_TEAM_MEMBER_FAIL, payload: error });

export const removeTeamMember = (teamId, userId, callback) => ({ type: REMOVE_TEAM_MEMBER, payload: { teamId, userId, callback } });
export const removeTeamMemberSuccess = (userId) => ({ type: REMOVE_TEAM_MEMBER_SUCCESS, payload: userId });
export const removeTeamMemberFail = (error) => ({ type: REMOVE_TEAM_MEMBER_FAIL, payload: error });

export const updateTeamMemberRole = (data, callback) => ({ type: UPDATE_TEAM_MEMBER_ROLE, payload: { data, callback } });
export const updateTeamMemberRoleSuccess = (member) => ({ type: UPDATE_TEAM_MEMBER_ROLE_SUCCESS, payload: member });
export const updateTeamMemberRoleFail = (error) => ({ type: UPDATE_TEAM_MEMBER_ROLE_FAIL, payload: error });

// Responsibilities
export const fetchTeamResponsibilities = (teamId) => ({ type: FETCH_TEAM_RESPONSIBILITIES, payload: teamId });
export const fetchTeamResponsibilitiesSuccess = (data) => ({ type: FETCH_TEAM_RESPONSIBILITIES_SUCCESS, payload: data });
export const fetchTeamResponsibilitiesFail = (error) => ({ type: FETCH_TEAM_RESPONSIBILITIES_FAIL, payload: error });

export const attachTeamResponsibility = (data, callback) => ({ type: ATTACH_TEAM_RESPONSIBILITY, payload: { data, callback } });
export const attachTeamResponsibilitySuccess = (item) => ({ type: ATTACH_TEAM_RESPONSIBILITY_SUCCESS, payload: item });
export const attachTeamResponsibilityFail = (error) => ({ type: ATTACH_TEAM_RESPONSIBILITY_FAIL, payload: error });

export const attachTeamResponsibilitiesBulk = (data, callback) => ({ type: ATTACH_TEAM_RESPONSIBILITIES_BULK, payload: { data, callback } });
export const attachTeamResponsibilitiesBulkSuccess = (response) => ({ type: ATTACH_TEAM_RESPONSIBILITIES_BULK_SUCCESS, payload: response });
export const attachTeamResponsibilitiesBulkFail = (error) => ({ type: ATTACH_TEAM_RESPONSIBILITIES_BULK_FAIL, payload: error });

export const detachTeamResponsibility = (data, callback) => ({ type: DETACH_TEAM_RESPONSIBILITY, payload: { data, callback } });
export const detachTeamResponsibilitySuccess = (data) => ({ type: DETACH_TEAM_RESPONSIBILITY_SUCCESS, payload: data });
export const detachTeamResponsibilityFail = (error) => ({ type: DETACH_TEAM_RESPONSIBILITY_FAIL, payload: error });

// Clear
export const clearTeamMessages = () => ({ type: CLEAR_TEAM_MESSAGES });
